import { v2Request } from './client';

/** Pilot GET /api/coupons/cccAppFormat — list for customer UI. */
export async function listCouponsCccFormat() {
  const data = await v2Request('/api/coupons/cccAppFormat');
  return Array.isArray(data?.coupons) ? data.coupons : [];
}

/**
 * Pilot POST /api/coupons/validate-coupon
 * @param {{ mobile: string, code: string, skus: string[], cartTotal: number }} p
 */
export async function validateCartCoupon({ mobile, code, skus, cartTotal }) {
  return v2Request('/api/coupons/validate-coupon', {
    method: 'POST',
    body: {
      mobile: mobile != null ? String(mobile).trim() : '',
      code: String(code || '').trim(),
      skus: Array.isArray(skus) ? skus : [],
      cartTotal: Number(cartTotal) || 0,
    },
  });
}
